// Using https://gridjs.io/
import { Grid } from "gridjs";
import "scss/components/gridjs-custom.scss";
import {GRIDJS_CURRENCY, GRIDJS_CONFIGS} from "./gridjsconfig";
import { localeRoot } from "../utils/locale";
import { producerWineTableFilter } from './producerWineTableFilter'

const gridjsTables = document.querySelectorAll('.js-table');

gridjsTables.forEach(gridJsTable => {
  const dataUri = gridJsTable.dataset.tabledatauri;
  const dataUriLocalise = gridJsTable.dataset.tablelocaliseuri;
  const gridConfigKey = gridJsTable.dataset.tableconfigkey;
  // Semi-lame passing of currency code to override default
  const gridCurrencyCode = gridJsTable.dataset.currencycode;
  const gridCurrencyLocale = gridJsTable.dataset.currencylocale;
  if (gridCurrencyCode && gridCurrencyLocale) {
    GRIDJS_CURRENCY.code = gridCurrencyCode;
    GRIDJS_CURRENCY.locale = gridCurrencyLocale.replace('_','-');
  }
  if(dataUri && (gridConfigKey in GRIDJS_CONFIGS)){
    const gridConfig = GRIDJS_CONFIGS[gridConfigKey];
    gridConfig.server.url = dataUriLocalise === 'true' ? localeRoot + dataUri.slice(1) : dataUri;
    const grid = new Grid(gridConfig).render(gridJsTable);
    // Example of rowClick to follow link...
    grid.on('rowClick', (e,row) => {
      const lastCell = row.cells[row.cells.length - 1];
      if (lastCell.data) {
        window.location.href = lastCell.data;
      }
    });
  }
})

producerWineTableFilter()
